export default {
    UNDEFINED: undefined,
    LOADING: 'LOADING',
    SUCCESS: 'SUCCESS',
    OK: 'SUCCESS',
    ERROR: 'ERROR',
    TRUE: true,
    FALSE: false,
}
